
// @ts-nocheck
import locale__opt_build_repo_l10n_locales_en_json from "../l10n/locales/en.json";
import locale__opt_build_repo_l10n_locales_sv_json from "../l10n/locales/sv.json";
import locale__opt_build_repo_l10n_locales_de_json from "../l10n/locales/de.json";
import locale__opt_build_repo_l10n_locales_pt_json from "../l10n/locales/pt.json";


export const localeCodes =  [
  "en-gb",
  "en-se",
  "en-de",
  "en-at",
  "en-pt",
  "sv-se",
  "de-de",
  "de-at",
  "pt-pt"
]

export const localeLoaders = {
  "en-gb": [{ key: "../l10n/locales/en.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_en_json), cache: true }],
  "en-se": [{ key: "../l10n/locales/en.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_en_json), cache: true }],
  "en-de": [{ key: "../l10n/locales/en.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_en_json), cache: true }],
  "en-at": [{ key: "../l10n/locales/en.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_en_json), cache: true }],
  "en-pt": [{ key: "../l10n/locales/en.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_en_json), cache: true }],
  "sv-se": [{ key: "../l10n/locales/sv.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_sv_json), cache: true }],
  "de-de": [{ key: "../l10n/locales/de.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_de_json), cache: true }],
  "de-at": [{ key: "../l10n/locales/de.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_de_json), cache: true }],
  "pt-pt": [{ key: "../l10n/locales/pt.json", load: () => Promise.resolve(locale__opt_build_repo_l10n_locales_pt_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en-gb",
      "language": "en-GB",
      "files": [
        "l10n/locales/en.json"
      ]
    },
    {
      "code": "en-se",
      "language": "en-SE",
      "files": [
        "l10n/locales/en.json"
      ]
    },
    {
      "code": "en-de",
      "language": "en-DE",
      "files": [
        "l10n/locales/en.json"
      ]
    },
    {
      "code": "en-at",
      "language": "en-AT",
      "files": [
        "l10n/locales/en.json"
      ]
    },
    {
      "code": "en-pt",
      "language": "en-PT",
      "files": [
        "l10n/locales/en.json"
      ]
    },
    {
      "code": "sv-se",
      "language": "sv-SE",
      "files": [
        "l10n/locales/sv.json"
      ]
    },
    {
      "code": "de-de",
      "language": "de-DE",
      "files": [
        "l10n/locales/de.json"
      ]
    },
    {
      "code": "de-at",
      "language": "de-AT",
      "files": [
        "l10n/locales/de.json"
      ]
    },
    {
      "code": "pt-pt",
      "language": "pt-PT",
      "files": [
        "l10n/locales/pt.json"
      ]
    }
  ],
  "defaultLocale": "en-gb",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": "l10n/locales/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://tiptapp.com",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "fallbackLocale": {
    "en-se": [
      "en-gb"
    ],
    "en-de": [
      "en-gb"
    ],
    "en-at": [
      "en-gb"
    ],
    "en-pt": [
      "en-gb"
    ],
    "de-at": [
      "de-de"
    ],
    "default": [
      "en-gb"
    ]
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en-gb",
    "language": "en-GB",
    "files": [
      {
        "path": "l10n/locales/en.json"
      }
    ]
  },
  {
    "code": "en-se",
    "language": "en-SE",
    "files": [
      {
        "path": "l10n/locales/en.json"
      }
    ]
  },
  {
    "code": "en-de",
    "language": "en-DE",
    "files": [
      {
        "path": "l10n/locales/en.json"
      }
    ]
  },
  {
    "code": "en-at",
    "language": "en-AT",
    "files": [
      {
        "path": "l10n/locales/en.json"
      }
    ]
  },
  {
    "code": "en-pt",
    "language": "en-PT",
    "files": [
      {
        "path": "l10n/locales/en.json"
      }
    ]
  },
  {
    "code": "sv-se",
    "language": "sv-SE",
    "files": [
      {
        "path": "l10n/locales/sv.json"
      }
    ]
  },
  {
    "code": "de-de",
    "language": "de-DE",
    "files": [
      {
        "path": "l10n/locales/de.json"
      }
    ]
  },
  {
    "code": "de-at",
    "language": "de-AT",
    "files": [
      {
        "path": "l10n/locales/de.json"
      }
    ]
  },
  {
    "code": "pt-pt",
    "language": "pt-PT",
    "files": [
      {
        "path": "l10n/locales/pt.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
